// Market prices for the GDPR representative cost article, from
// gdpr-rep-prices.json (published figures, anonymised P1-P8). Everything the
// article states about them is computed here: euro values at the ECB rate,
// Gabsor's yearly figure, the cheaper-than-Gabsor count and the price ranges
// in the comparison table.
import data from './gdpr-rep-prices.json';
import { FROM_PRICE, usd } from '../../../lib/pricing.js';

export const RATES = data.rates;
export const RETRIEVED = data.retrieved;

const toEur = (amount, currency) => (currency === 'EUR' ? amount : amount / RATES[currency]);

// Yearly price in euros, rounded to the euro. A monthly price counts 12 months.
export const PROVIDERS = data.providers
  .map((p) => {
    const yearly = p.per === 'month' ? p.price * 12 : p.price;
    return { ...p, yearly, eur: Math.round(toEur(yearly, p.currency)), euUk: p.scope === 'eu-uk' };
  })
  .sort((a, b) => a.eur - b.eur);

// Gabsor Essential billed annually: the monthly from-price x 12, in USD.
export const GABSOR_YEAR_USD = FROM_PRICE * 12;
export const GABSOR_YEAR_EUR = Math.round(GABSOR_YEAR_USD / RATES.USD);
export const GABSOR_YEAR_LABEL = `${usd(GABSOR_YEAR_USD)} (${usd(FROM_PRICE)} × 12)`;

// Providers that publish an EU + UK price below Gabsor's, in euros. Providers
// without a published EU + UK price are not counted either way.
export const CHEAPER_EU_UK = PROVIDERS.filter((p) => p.euUk && p.eur < GABSOR_YEAR_EUR).length;
const WORDS = ['None', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight'];
export const CHEAPER_EU_UK_WORD = WORDS[CHEAPER_EU_UK] ?? String(CHEAPER_EU_UK);

// Comparison-table groups: the three lowest-priced of the eight, and the rest.
export const CHEAPEST = PROVIDERS.slice(0, 3);
export const MID_RANGE = PROVIDERS.slice(3);

export const eur = (n) => `€${n.toLocaleString('en-US')}`;
const span = (vals) => (vals.length === 1 ? eur(vals[0]) : `${eur(Math.min(...vals))}–${eur(Math.max(...vals))}`);

// "€588–€1,425; 2 of 5 publish no EU + UK price (EU price €490–€1,140)"
export const priceCell = (group) => {
  const both = group.filter((p) => p.euUk);
  const euOnly = group.filter((p) => !p.euUk);
  const from = both.length === 1 && both[0].from ? 'From ' : '';
  const head = both.length ? `${from}${span(both.map((p) => p.eur))}` : 'Not published';
  const tail = euOnly.length ? `; ${euOnly.length} of ${group.length} publish no EU + UK price (EU price ${span(euOnly.map((p) => p.eur))})` : '';
  return `${head}${tail}`;
};

// Axis maximum: the next multiple of 500 above the highest value plotted.
export const AXIS_MAX = (Math.floor(Math.max(GABSOR_YEAR_EUR, ...PROVIDERS.map((p) => p.eur)) / 500) + 1) * 500;
